export default __webpack_public_path__ + "static/media/on-the-range-enchiladas.65e0b963.jpeg";